import { Button } from '@assembly-js/design-system';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { CRM_CLIENTS_PAGE } from 'src/constants';
import { PortalConfigContext } from 'src/context';

import { ChecklistWrapper } from './ChecklistWrapper';
import { useStudioChecklist } from './useStudioChecklist';

interface Props {
  backgroundColor: string;

  sidebarColor: string;
  textColor: string;
}

/**
 * Client-portal variant of the Studio "Getting started" card. Reuses the shared
 * card shell and the studio checklist state; in place of task rows it offers a
 * "Return to CRM" action back to the dashboard, styled with the portal accent.
 */
export const ClientChecklist = ({
  backgroundColor,
  sidebarColor,
  textColor,
}: Props) => {
  const { t } = useTranslation();
  const { brand, theme } = useContext(PortalConfigContext);
  const {
    completionPct,
    isCollapsed,
    toggleCollapse,
    navigateAndCloseMobileSidebar,
  } = useStudioChecklist();

  // The client "Return to CRM" button uses the portal's configured accent
  // color, falling back to the portal primary when no accent is set.
  const accentColor = brand.clientAccentColor || theme.palette.primary.main;

  return (
    <ChecklistWrapper
      completionPct={completionPct}
      isCollapsed={isCollapsed}
      onToggleCollapse={toggleCollapse}
      isClient
      backgroundColor={backgroundColor}
      sidebarColor={sidebarColor}
      textColor={textColor}
    >
      <div className="box-border px-2 pb-2 pt-1">
        <Button
          label={t(
            ($) => $.page_apps.app_builder.getting_started.return_to_crm,
          )}
          variant="primary"
          size="sm"
          className="w-full"
          style={{
            backgroundColor: accentColor,
            borderColor: accentColor,
          }}
          onClick={() => navigateAndCloseMobileSidebar(CRM_CLIENTS_PAGE.path)}
        />
      </div>
    </ChecklistWrapper>
  );
};
